import { ReactElement } from 'react';

interface Props {
    children?: ReactElement;
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function SuccessCard(props: Props): JSX.Element {
    const { children } = props;
    return (
        <div className="flex items-center justify-center relative mt-8">
            <div className={`w-full md:w-1/2 text-white bg-sm-rent items-center text-center rounded-3xl px-10 py-2 `}>
                {children}
            </div>
        </div>
    );
}
